export const SetUser = (data) => {
  window.localStorage.setItem("User", btoa(JSON.stringify(data)));
};
export const GetUser = () => {
  console.log();
  return (
    window.localStorage.getItem("User") != null &&
    JSON.parse(atob(window.localStorage.getItem("User")))
  );
};
export const RemoveUser = () => {
  window.localStorage.removeItem("User");
};
